<template>
    <div style="display: none;"></div>
</template>

<script>
    export default {
        mounted() {
            this.checkAuth();
        },
        methods: {
            async checkAuth() {
                try {
                    const response = await axios.get('/customer/auth/check');
                    if (response.data.authenticated) {
                        window.Bus.$emit('auth-user-updated', response.data.user);
                    } else {
                         window.Bus.$emit('auth-user-updated', null);
                    }
                } catch (error) {
                    // console.error('Auth check failed:', error);
                    window.Bus.$emit('auth-user-updated', null);
                }
            }
        }
    }
</script>
